import { computed, reactive, toRefs, nextTick } from 'vue'
import moment from 'moment'
import { getMiniGameAdProfitConfig } from '@/api/report.model'

export const useTableData = () => {
  const tableModel = reactive({
    tableData: [],
    tableLoading: false,
    pager: {
      pageIndex: 1,
      pageSize: 50,
      total: 0
    }
  })

  const duplicateGameIds = computed(() => tableModel.tableData.map(i => i.gameId))

  function addTableRow() {
    tableModel.tableData.push({ gameId: '', appid: '', verifyStatus: 0, verifyMsg: '', loading: false })
    nextTick(() => {
      const els = document.querySelectorAll('.el-table .verify')
      const [lastEl] = Array.from(els).slice(-1) || []
      if (lastEl) {
        lastEl.parentNode.parentNode.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }
    })
  }

  function getTableList() {
    tableModel.tableLoading = true
    getMiniGameAdProfitConfig().then((data) => {
      if (data) {
        tableModel.tableData = data.map(i => ({ ...i, createTime: moment(i.createTime).format('YYYY-MM-DD HH:mm:ss') }))
      }
    }).finally(() => {
      tableModel.tableLoading = false
    })
  }

  return {
    ...toRefs(tableModel),
    duplicateGameIds,
    getTableList,
    addTableRow
  }
}
